export default "__VITE_ASSET__BhiBD0YP__"